import React from 'react';

import NotFoundView from '../../../../not-found-view';

type SelectionModalContentProps = {
    subtitle: string;
};

const NoItemsView = ({ subtitle }: SelectionModalContentProps) => {
    return <NotFoundView message={subtitle} />;
};

export default NoItemsView;
